import cs from "classnames";

import { Loader, RoundedBox } from "@braintrust/braintrust-ui-components";
import { JobEmployerDetails } from "@js/apps/employer/components";
import { Rate } from "@js/apps/jobs/components/rate";
import type { EmployerPublicProfile } from "@js/types/employer";
import type { FreelancerBidListItem, Job } from "@js/types/jobs";

import {
  JobHeader,
  JobStatus,
  MatchersListing,
  WorkTimeDetail,
} from "../../components";
import { Description } from "../../components/job-description/section-description";

import style from "./style.module.scss";

type BYOTJobDetailsProps = {
  job: Job;
  bid?: FreelancerBidListItem;
  employer: EmployerPublicProfile | undefined;
};

export const BYOTJobDetails = ({ job, bid, employer }: BYOTJobDetailsProps) => {
  return (
    <main>
      <JobHeader job={job} bid={bid} />
      <section className={cs(style.jobDetails, style.jobDetailsByot)}>
        <div className={style.jobBasicDetails}>
          <RoundedBox className={style.jobBasicDetailsWrapper}>
            <WorkTimeDetail
              expectedHoursPerWeek={job.expected_hours_per_week}
              variant="details"
              withLabel
              shortened
            />
          </RoundedBox>
        </div>
        <div className={style.jobDetailsByotContent}>
          <div className={style.jobStatusBox}>
            <JobStatus job={job} bid={bid} className={style.jobStatus} />
          </div>
          <div className={style.jobRate}>
            <Rate job={job} bid={bid} />
          </div>
          {job.description && (
            <div className={style.jobDetailsByotDescription}>
              <RoundedBox>
                <Description
                  description={job.description}
                  title="Job description"
                />
              </RoundedBox>
            </div>
          )}
        </div>
        <div
          className={cs(
            style.jobEmployerColumn,
            style.jobDetailsByotEmployerColumn,
          )}
        >
          <div className={style.jobEmployer}>
            {!employer ? (
              <Loader />
            ) : (
              <RoundedBox>
                <JobEmployerDetails employer={employer} jobId={job.id} />
              </RoundedBox>
            )}
          </div>
          <div>
            <MatchersListing job={job} />
          </div>
        </div>
      </section>
    </main>
  );
};
